module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// D:/Projects/dev/peer/client/node_modules/babel-runtime/node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 890
// module chunks = 0